import React, { useState } from "react";
import HrLayout from "../../layouts/HrLayout";
import Card from "../../components/UI/Card";
import Button from "../../components/UI/Button";

export default function Departments() {
  const [search, setSearch] = useState("");
  const [filterHead, setFilterHead] = useState("");

  const [departments, setDepartments] = useState([
    {
      id: 1,
      name: "Information Technology",
      head: "John Doe",
      employees: 42,
      description: "Responsible for infrastructure, network, and software development.",
      createdOn: "2022-04-18",
    },
    {
      id: 2,
      name: "Human Resources",
      head: "Jane Smith",
      employees: 18,
      description: "Handles recruitment, payroll, and employee relations.",
      createdOn: "2021-11-09",
    },
    {
      id: 3,
      name: "Finance",
      head: "Mike Johnson",
      employees: 12,
      description: "Manages company accounts, billing, and budgeting.",
      createdOn: "2020-08-05",
    },
  ]);

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this department?")) {
      setDepartments(departments.filter((dep) => dep.id !== id));
    }
  };

  const filteredData = departments.filter((dep) =>
    dep.name.toLowerCase().includes(search.toLowerCase()) &&
    (filterHead ? dep.head === filterHead : true)
  );

  return (
    <HrLayout>
      <div className="p-6 bg-gray-100 min-h-screen">

        {/* Page Header */}
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-bold text-gray-800">Department Management</h1>
          <Button
            className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-lg text-sm shadow-md"
            onClick={() => alert("Open Add Department Modal")}
          >
            + Add New Department
          </Button>
        </div>

        {/* Quick Insights */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <Card className="p-5 bg-blue-50 border-l-4 border-blue-600 shadow">
            <h2 className="text-gray-600 text-sm">Total Departments</h2>
            <p className="text-3xl font-bold text-blue-700">{departments.length}</p>
          </Card>

          <Card className="p-5 bg-green-50 border-l-4 border-green-600 shadow">
            <h2 className="text-gray-600 text-sm">Total Employees</h2>
            <p className="text-3xl font-bold text-green-700">
              {departments.reduce((sum, dep) => sum + dep.employees, 0)}
            </p>
          </Card>

          <Card className="p-5 bg-purple-50 border-l-4 border-purple-600 shadow">
            <h2 className="text-gray-600 text-sm">Oldest Department</h2>
            <p className="text-lg font-semibold text-purple-700">
              {departments.reduce((oldest, dep) =>
                dep.createdOn < oldest.createdOn ? dep : oldest
              ).name}
            </p>
          </Card>
        </div>

        {/* Filters */}
        <Card className="p-5 mb-6">
          <h2 className="text-lg font-semibold mb-4">Filters</h2>
          <div className="grid md:grid-cols-3 gap-4">
            <input
              type="text"
              placeholder="Search by department name..."
              className="border p-2 rounded-md shadow-sm w-full"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />

            <select
              className="border p-2 rounded-md shadow-sm w-full"
              value={filterHead}
              onChange={(e) => setFilterHead(e.target.value)}
            >
              <option value="">Filter by Department Head</option>
              {departments.map((dep) => (
                <option key={dep.id} value={dep.head}>{dep.head}</option>
              ))}
            </select>

            <Button className="bg-gray-700 text-white rounded-md">
              Clear Filters
            </Button>
          </div>
        </Card>

        {/* Department Table */}
        <Card className="shadow-lg overflow-hidden">
          <table className="min-w-full bg-white rounded">
            <thead className="bg-gray-100 text-gray-600 text-sm uppercase">
              <tr>
                <th className="py-3 px-6 text-left">Department</th>
                <th className="py-3 px-6 text-left">Head</th>
                <th className="py-3 px-6 text-center">Employees</th>
                <th className="py-3 px-6 text-left">Created On</th>
                <th className="py-3 px-6 text-center">Actions</th>
              </tr>
            </thead>
            <tbody className="text-gray-700 text-sm">
              {filteredData.map((dep) => (
                <tr key={dep.id} className="border-b hover:bg-gray-50 transition-all">
                  <td className="py-3 px-6">
                    <p className="font-semibold">{dep.name}</p>
                    <p className="text-gray-500 text-xs">{dep.description}</p>
                  </td>

                  <td className="py-3 px-6">{dep.head}</td>

                  <td className="py-3 px-6 text-center">
                    <span className="text-sm bg-blue-100 text-blue-700 px-3 py-1 rounded-full">
                      {dep.employees}
                    </span>
                  </td>

                  <td className="py-3 px-6">{dep.createdOn}</td>

                  <td className="py-3 px-6 text-center">
                    <div className="flex justify-center gap-2">
                      <Button
                        className="bg-yellow-400 hover:bg-yellow-500 text-white px-3 py-1 rounded"
                        onClick={() => alert("Edit department")}
                      >
                        Edit
                      </Button>

                      <Button
                        className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded"
                        onClick={() => handleDelete(dep.id)}
                      >
                        Delete
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>

      </div>
    </HrLayout>
  );
}
